// extracted by mini-css-extract-plugin
module.exports = {"container":"SuccessPage_container__1MuCT"};